import React from 'react';
import { Scale, Shield, CheckCircle } from 'lucide-react';

const Hero = () => {
  return (
    <section className="pt-32 pb-24 bg-gradient-to-br from-slate-900 via-blue-950 to-slate-800 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/8112170/pexels-photo-8112170.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Legal background"
          className="w-full h-full object-cover opacity-40" />

        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/70 via-blue-950/70 to-slate-800/70"></div>
      </div>
      
      {/* Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
      </div>

      {/* Blue accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge - ATUALIZADO */}
          <div className="inline-flex items-center space-x-2 bg-red-500/20 border border-red-500/30 rounded-full px-6 py-2 mb-8">
            <Scale className="w-5 h-5 text-red-400" />
            <span className="text-red-400 font-semibold">❌ Nome negativado indevidamente no SPC ou Serasa?</span>
          </div>

          {/* HEADLINE - ATUALIZADA */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
            Teve o nome <span className="text-blue-400">negativado indevidamente?</span>
          </h1>

          {/* SUBHEADLINE - ATUALIZADA */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
            Empresas não podem negativar seu nome sem comprovar a dívida. Em muitos casos, é possível retirar a negativação e pedir indenização.
          </p>

          {/* BULLETS DE IDENTIFICAÇÃO - NOVO */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8 mb-10 max-w-2xl mx-auto">
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">Dívida que você não reconhece</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">Cobrança mesmo após pagamento</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">Nome negativado sem aviso prévio</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">Erro de banco, operadora ou financeira</span>
              </div>
              <div className="flex items-start space-x-3 md:col-span-2">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">SPC ou Serasa bloqueando seu crédito injustamente</span>
              </div>
            </div>
          </div>

          {/* CTA - ATUALIZADO */}
          <div className="flex flex-col items-center space-y-6">
            <a
              href="https://wa.me/5521996853559?text=Olá, preciso avaliar meu caso de negativação indevida"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-12 py-6 rounded-2xl font-bold text-xl transition-all duration-300 flex items-center space-x-4 transform hover:scale-105 shadow-2xl border-2 border-green-500/50">

              <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z">seja atendido por nossa equipe agora</path>
              </svg>
              <span>Seja atendido por nossa equipe agora</span>
            </a>

            {/* MICRO-CONFIANÇA - ATUALIZADA */}
            <div className="flex items-center space-x-3 text-gray-400">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span>Atendimento direto com advogada especialista • Resposta rápida no WhatsApp</span>
            </div>

            {/* AUTORIDADE - ATUALIZADA */}
            <p className="text-sm text-gray-500 mt-2">
              Advogada especialista em Direito do Consumidor • OAB/RJ 245.846 • 15+ anos de experiência
            </p>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-3 gap-8 mt-16 pt-12 border-t border-white/10">
            <div>
              <div className="text-4xl font-bold text-blue-500 mb-2">15+</div>
              <div className="text-gray-400 text-sm">Anos de Experiência</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-400 mb-2">500+</div>
              <div className="text-gray-400 text-sm">atuações em processos e procedimentos jurídicos </div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-400 mb-2">RJ</div>
              <div className="text-gray-400 text-sm">Atendimento Online</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Hero;